<script lang="ts">
	import { chatT } from '@repo/commons/i18n/chat'
	import { Button, ButtonType, Dropdown } from '@repo/commons/components'
	import type { DropdownItem } from '@repo/commons/models'

	interface Props {
		headerColor?: string
		selectedLanguage?: DropdownItem | null
		chatTitle?: string
		visibleLangAction?: boolean
		visibleNewChatAction?: boolean
		visibleMinimizeAction?: boolean
		onSelectLanguage?: ((item: DropdownItem) => void) | null
		onNewChat?: (() => void) | null
		onFeedback?: (() => void) | null
	}

	const {
		headerColor = '#007acc',
		selectedLanguage = null,
		chatTitle = '',
		visibleLangAction = true,
		visibleNewChatAction = true,
		visibleMinimizeAction = true,
		onNewChat = null,
		onFeedback = null,
		onSelectLanguage = null
	}: Props = $props()

	const flags: DropdownItem[] = [
		// { id: 'EN', label: 'EN', icon: 'britishFlag' },
		{ id: 'DE', label: 'DE', icon: 'germanFlag' }
	]

	function handleItemSelect(item: DropdownItem) {
		onSelectLanguage?.(item)
	}

	const headerColorValue = $derived(headerColor)
</script>

<div class="chatHeader" style="background-color: {headerColorValue};">
	<span class="title">{chatTitle}</span>
	<div class="actions">
		{#if visibleLangAction}
			<Dropdown items={flags} onSelect={handleItemSelect} placement="bottom-start">
				{#snippet children({ toggle })}
					{#key selectedLanguage?.id}
						<Button
							buttonText={$chatT('CustomerSupport.language')}
							buttonType={ButtonType.CUSTOM}
							onclick={toggle}
							iconProps={{ name: selectedLanguage?.icon as string }}
						/>
					{/key}
				{/snippet}
			</Dropdown>
		{/if}
		{#if visibleNewChatAction}
			<Button
				buttonText={$chatT('CustomerSupport.newChat')}
				buttonType={ButtonType.CUSTOM}
				iconProps={{ name: 'plus', size: 'md', class: 'text-white' }}
				onclick={onNewChat}
			/>
		{/if}
		{#if visibleMinimizeAction}
			<Button
				buttonText={$chatT('CustomerSupport.minimize')}
				buttonType={ButtonType.CUSTOM}
				iconProps={{ name: 'chevronDown', size: 'md', class: 'text-white' }}
				onclick={onFeedback}
			/>
		{/if}
	</div>
</div>

<style lang="postcss">
	.chatHeader {
		@apply flex justify-between items-center self-stretch;
		@apply [padding:16px_20px];
	}

	.title {
		@apply text-white font-semibold not-italic;
		@apply [font-size:20px] [line-height:28px];
	}

	.actions {
		@apply flex items-center gap-3;
	}

	:global(.dropdown-wrapper .button-class) {
		@apply !p-0 h-auto bg-transparent;
	}

	:global(.dropdown-wrapper .button-class .icon-wrapper) {
		@apply w-auto;
	}

	:global(.dropdown-wrapper .button-class.icon-only.small) {
		@apply h-auto bg-transparent border-none;
	}

	.chatHeader :global(.button-class .inner-container) {
		gap: 0.25rem;
		flex-direction: column;
	}

	.chatHeader :global(.button-class .inner-container .button-text) {
		@apply text-white text-[12px] font-normal leading-[16px];
	}
</style>
